/* eslint-disable react/no-array-index-key */
/* eslint-disable no-else-return */
/* eslint-disable prettier/prettier */
import { useCallback, useEffect, useState } from "react";
import { format, formatDistanceToNow } from "date-fns";
import { useLazyQuery } from "@apollo/client";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  IconButton,
  Chip,
  Tooltip,
  TextField,
  useTheme,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { searchTicket } from "../../redux/action";
import { createFetch, deleteTicket } from "../../gql/queries/ticket";
import { usePopup } from "../../context/commonPop";
import useQuery from "../../hooks/allQuery";
import TicketUpdateForm from "./TicketUpdateForm";
import DeletePopup from "./deletePopup";

function TicketListing({ ticketsFetch, setTicketsFetch }) {
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [selectedTicket, setSelectedTicket] = useState({});
  const [deleteDisable, setDeleteDisable] = useState(false);
  const [openChild, setOpenChild] = useState(false);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const dispatch = useDispatch();
  const { userData } = useSelector(state => state.reducer);
  const ticketSearchValue = useSelector(state => state.ticketReducer.ticketSearch);
  const [CREATE_FETCH] = useLazyQuery(createFetch, { fetchPolicy: "cache-first" });
  const [DELETE_TICKET] = useLazyQuery(deleteTicket, { fetchPolicy: "network-only" });
  const { allQuery } = useQuery();
  const { handleOpen } = usePopup();
  const navigate = useNavigate();

  const formatDate = dateString => {
    const createdAt = new Date(dateString);
    const now = new Date();
    const diffInDays = Math.floor((now.getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24));

    if (diffInDays === 1) {
      return "Yesterday";
    } else if (diffInDays > 1) {
      return format(createdAt, "dd MMM yyyy");
    } else {
      return formatDistanceToNow(createdAt, { addSuffix: true });
    }
  };

  const currentFilter = useSelector(state => state.ticketReducer.currentFilter);

  const getVisibleTickets = (tickets, filter, ticketSearch) => {
    const searchStr = ticketSearch.toLowerCase();

    const matchesSearch = ticket =>
      Object.keys(ticket).some(key => {
        const value = ticket[key];
        console.log(value, "value");
        if (value == null) return false;
        return value.toString().toLowerCase().includes(searchStr);
      });

    switch (filter) {
      case "total_tickets":
        return tickets?.filter(ticket => !ticket.isDeleted && matchesSearch(ticket));

      case "Pending":
        return tickets?.filter(ticket => !ticket.isDeleted && ticket.Status === "Pending" && matchesSearch(ticket));

      case "Closed":
        return tickets?.filter(ticket => !ticket.isDeleted && ticket.Status === "Closed" && matchesSearch(ticket));

      case "Open":
        return tickets?.filter(ticket => !ticket.isDeleted && ticket.Status === "Open" && matchesSearch(ticket));

      default:
        throw new Error(`Unknown filter: ${filter}`);
    }
  };

  const tickets = useSelector(state => getVisibleTickets(ticketsFetch, state.ticketReducer.currentFilter, state.ticketReducer.ticketSearch));
  console.log(tickets, "This is my tickets");
  const ticketBadge = ticket =>
    ticket.Status === "Open"
      ? theme.palette.success.light
      : ticket.Status === "Closed"
      ? theme.palette.error.light
      : ticket.Status === "Pending"
      ? theme.palette.warning.light
      : ticket.Status === "Moderate"
      ? theme.palette.primary.light
      : "primary";

  const handleDelete = useCallback(() => {
    setDeleteDisable(true);
    allQuery({
      QUERY: DELETE_TICKET,
      variables: { ticketIsDeleteId: deleteId },
      type: "delete",
      cacheQueryData: {
        cacheQuery: createFetch,
        variablesCache: {
          userId: userData.id,
        },
      },
      onCompleteFunc: () => {
        setDeleteDisable(false);
        handleOpen(true, "Ticket deleted successfully");
      },
      onErrorFunc: error => {
        console.log("error", error);
        setDeleteDisable(false);
      },
    });
    setOpenChild(false);
  }, [deleteId, userData.id, createFetch, allQuery, DELETE_TICKET, setDeleteDisable, setOpenChild, handleOpen]);

  const handleOpenPopup = id => {
    setDeleteId(id);
    setOpenChild(true);
  };

  useEffect(() => {
    if (userData?.id) {
      allQuery({
        QUERY: CREATE_FETCH,
        variables: {
          userId: userData.id,
        },
        onCompleteFunc: ({ ticketgetAll }) => {
          setTicketsFetch(ticketgetAll);
          setLoading(false);
        },
        onErrorFunc: err => {
          console.log(err);
          setLoading(false);
        },
      });
    }
  }, [userData]);

  return loading ? (
    <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }} mt={4}>
      <CircularProgress size={60} />
    </Box>
  ) : (
    <Box>
      <Box sx={{ maxWidth: "260px", ml: "auto", mt: "32px", "& .MuiFormControl-root": { "& .MuiInputBase-root": { paddingRight: "4px" } } }} mb={3}>
        <TextField
          size="small"
          label="Search by description or Ticket ID"
          fullWidth
          onChange={e => dispatch(searchTicket(e.target.value))}
          value={ticketSearchValue}
          InputProps={{
            endAdornment: ticketSearchValue && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => dispatch(searchTicket(""))} sx={{ "&:focus": { outline: "none" } }}>
                  <ClearIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {tickets.length > 0 ? (
        <Box mt={4}>
          <DeletePopup open={openChild} setOpen={setOpenChild} handleDelete={handleDelete} msg={`${deleteId}`} />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="h6">Ticket ID</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">Description</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">Image</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">Status</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6">Date</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="h6">Action</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tickets.map(ticket => (
                  <TableRow key={ticket.ticketId} hover>
                    <TableCell sx={{ color: theme.palette.primary.main }}>
                      <Box
                        onClick={() => {
                          setSelectedTicket(ticket);
                          navigate(`/support/chat/${ticket.ticketId}`);
                        }}
                        sx={{ width: "max-content", cursor: "pointer" }}
                      >
                        {ticket.ticketId}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box>
                        <Typography variant="h6" fontWeight={600} noWrap>
                          {ticket.type}
                        </Typography>
                        <Typography color="textSecondary" noWrap sx={{ maxWidth: "250px" }} variant="subtitle2" fontWeight={400}>
                          {ticket.description}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {ticket?.images?.length > 0 ? (
                        ticket.images
                          .slice(0, 2)
                          .map((img, index) => <img key={index} src={img} alt="not found" width={35} height={35} style={{ marginRight: "5px", borderRadius: "5px" }} />)
                      ) : (
                        <span>Not Available</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        sx={{
                          backgroundColor: ticketBadge(ticket),
                        }}
                        size="small"
                        label={ticket.Status}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1">{formatDate(new Date(ticket.createdAt), "dd MMM yyyy")}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="Delete Ticket">
                        <IconButton
                          disabled={deleteDisable}
                          onClick={() => {
                            handleOpenPopup(ticket.ticketId);
                          }}
                          onFocus={e => e.target.blur()}
                          sx={{
                            "&:focus": {
                              outline: "none",
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TicketUpdateForm open={open} setOpen={setOpen} selectedTicket={selectedTicket} />
        </Box>
      ) : (
        <Box sx={{ padding: "100px 0px 75px" }}>
          <Typography sx={{ textAlign: "center", fontSize: "16px", fontWeight: "900" }}>
            {ticketSearchValue.trim()
              ? "It looks like there are no tickets matching your search."
              : currentFilter === "Pending"
              ? "There are no Pending tickets assigned to you at the moment."
              : currentFilter === "Closed"
              ? "There are no Closed tickets assigned to you at the moment."
              : currentFilter === "Open"
              ? "There are no Open tickets assigned to you at the moment."
              : currentFilter === "total_tickets"
              ? "There are no tickets assigned to you at the moment."
              : "No tickets found."}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
export default TicketListing;
